(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["terrasolis-quiz"] && !Shopify.designMode) return;
  try {
    
(() => {
  const questions = [
    ['Quando scegli un alimento, cosa conta di più?', 'Un profilo nutrizionale adatto alla mia routine attiva.', 'Ingredienti chiari e una scelta consapevole.', 'Un gusto nuovo che mi sorprenda.', 'Una soluzione semplice per le mie giornate piene.'],
    ['Cosa ti farebbe scegliere una nuova pasta?', 'Una proposta interessante per i giorni in cui mi alleno.', 'Poter leggere bene ingredienti e valori nutrizionali.', 'Una ricetta o un formato diverso dal solito.', 'Avere già una selezione pronta da provare.'],
    ['Quale primo piatto ti incuriosisce di più?', 'Un piatto con la varietà Proteica naturale.', 'Una versione Integrale da abbinare a verdure di stagione.', 'Un gusto originale, come Curcuma e Pepe o Mirtillo.', 'Una ricetta facile da preparare con ciò che ho in frigo.'],
    ['Quanto ti piace scegliere ogni dettaglio?', 'Mi piace confrontare i valori nutrizionali delle varianti.', 'Voglio capire bene che cosa sto acquistando.', 'Adoro sperimentare combinazioni e sapori.', 'Preferisco una selezione pronta e ben spiegata.'],
    ['Qual è la tua motivazione per provare TerraSolis?', 'Variare i pasti della mia routine sportiva.', 'Scoprire ingredienti e ricette con attenzione.', 'Portare qualcosa di originale in tavola.', 'Rendere più semplice decidere cosa cucinare.'],
    ['Come immagini il tuo primo assaggio?', 'Partire dalle varietà Proteica e confrontarle.', 'Iniziare con un gusto familiare e poi ampliare.', 'Provare più gusti possibili nella stessa Box.', 'Ricevere una Box già composta senza pensarci troppo.'],
    ['Cosa guardi per primo su una confezione?', 'La tabella nutrizionale.', 'La lista degli ingredienti.', 'Il gusto e la storia del prodotto.', 'Il formato e come cucinarlo.'],
    ['Con quanto anticipo decidi il pranzo?', 'Organizzo i pasti attorno ai miei impegni e allenamenti.', 'Mi prendo il tempo per scegliere con criterio.', 'Decido in base a ciò che mi ispira.', 'Spesso all’ultimo momento.'],
    ['Quale frase ti somiglia di più?', 'Mi piace avere obiettivi e una routine.', 'Cerco informazioni prima di provare un prodotto.', 'Mangiare è anche esplorare.', 'Mi servono opzioni facili da gestire.'],
    ['Che cosa vorresti trovare in una Box?', 'Più varianti Proteica da confrontare.', 'Una panoramica chiara degli ingredienti.', 'Un mix di gusti e formati sorprendenti.', 'Dodici porzioni pronte da tenere in dispensa.'],
    ['Come scegli una ricetta?', 'Cerco un piatto adatto al mio programma.', 'Punto su ingredienti che conosco.', 'Seguo la curiosità e sperimento.', 'Scelgo qualcosa di veloce e affidabile.'],
    ['Quale momento ti darebbe più soddisfazione?', 'Trovare una nuova pasta per la mia routine.', 'Fare una scelta informata.', 'Scoprire il mio nuovo gusto preferito.', 'Mettere in tavola qualcosa di buono con poco sforzo.'],
    ['Se dovessi iniziare oggi, che cosa preferiresti?', 'Una Box centrata sulle varietà Proteica.', 'Una Box che mi faccia conoscere la gamma.', 'Una Box con più sapori da scoprire.', 'Una Box già pronta: scelgo e basta.']
  ];
  const profiles = [
    { title: 'Campione in ascesa', lead: 'Ti piace scegliere con un obiettivo e confrontare le opzioni. Per te la pasta è anche una parte piacevole della tua routine attiva.', advice: 'Parti dalle varietà Proteica naturale, poi confronta Spinaci, Curcuma e Pepe e Integrale. La Box Performance Starter te le fa provare insieme, senza dover comporre dodici gusti uno per uno.', product: 'performance' },
    { title: 'Esploratore consapevole', lead: 'Prima di scegliere vuoi capire cosa c’è nel piatto. Ingredienti, ricette e possibilità di confronto contano più degli slogan.', advice: 'Parti dalla varietà che ti incuriosisce, confronta ingredienti e valori sulla confezione e poi prova un’altra ricetta. La Box Completa è il modo più diretto per conoscere la gamma e trovare ciò che preferisci.', product: 'discovery' },
    { title: 'Pioniere del sapore', lead: 'La curiosità è il tuo ingrediente principale. Ti piace sperimentare gusti e formati, e trovare nuovi abbinamenti.', advice: 'Scegli la Box Completa: accanto alle varietà Proteica trovi Mirtillo, Melograno e Lampone. Prova due gusti con lo stesso condimento semplice: sentirai meglio le differenze e scoprirai il tuo preferito.', product: 'discovery' },
    { title: 'Navigatore pratico', lead: 'Vuoi mangiare con gusto senza trasformare ogni pasto in una lunga decisione. Una scelta pronta e chiara vale molto per te.', advice: 'Inizia con una Box già composta. La Box Performance Starter ha dodici bustine da 100 g e più varietà Proteica: scegli il formato che ti ispira e tieni le altre porzioni per i prossimi pasti.', product: 'performance' }
  ];
  const firstTaste = {
    performance: ['Fiaccole Proteica naturale', 'Fusilli Proteica Integrale', 'Fusilli Curcuma e Pepe', 'Penne Proteica naturale'],
    discovery: ['Fusilli Proteica naturale', 'Fusilli Proteica Integrale', 'Fusilli al Mirtillo oppure Fiaccole al Melograno', 'Fusilli Proteica naturale']
  };
  document.querySelectorAll('[data-ts-quiz]').forEach((root) => {
    const intro = root.querySelector('[data-ts-intro]');
    const game = root.querySelector('[data-ts-game]');
    const result = root.querySelector('[data-ts-result]');
    const questionEl = root.querySelector('[data-ts-question]');
    const optionsEl = root.querySelector('[data-ts-options]');
    const countEl = root.querySelector('[data-ts-count]');
    const progressEl = root.querySelector('[data-ts-progress]');
    const fillEl = root.querySelector('[data-ts-progress-fill]');
    let index = 0;
    let answers = [];
    const renderQuestion = () => {
      intro.hidden = true;
      result.hidden = true;
      game.hidden = false;
      const question = questions[index];
      countEl.textContent = `Domanda ${index + 1} di ${questions.length}`;
      progressEl.setAttribute('aria-valuenow', String(index));
      fillEl.style.width = `${index / questions.length * 100}%`;
      questionEl.textContent = question[0];
      optionsEl.replaceChildren();
      question.slice(1).forEach((option, optionIndex) => {
        const button = document.createElement('button');
        const marker = document.createElement('span');
        button.type = 'button';
        button.className = 'ts-quiz__option';
        marker.textContent = String.fromCharCode(65 + optionIndex);
        button.append(marker, document.createTextNode(option));
        button.addEventListener('click', () => {
          answers[index] = optionIndex;
          index += 1;
          if (index < questions.length) renderQuestion();
          else renderResult();
        });
        optionsEl.append(button);
      });
      root.querySelector('[data-ts-back]').hidden = index === 0;
      questionEl.focus({ preventScroll: true });
    };
    const renderResult = () => {
      const scores = [0, 0, 0, 0];
      answers.forEach(answer => { scores[answer] += 1; });
      const ranked = [0, 1, 2, 3].sort((a, b) => scores[b] - scores[a] || (answers[answers.length - 1] === b) - (answers[answers.length - 1] === a) || a - b);
      const winner = ranked[0];
      const profile = profiles[winner];
      game.hidden = true;
      result.hidden = false;
      root.querySelector('[data-ts-result-title]').textContent = profile.title;
      root.querySelector('[data-ts-result-lead]').textContent = profile.lead;
      root.querySelector('[data-ts-advice]').textContent = profile.advice;
      root.querySelector('[data-ts-first-taste]').textContent = `La tua prima bustina: ${firstTaste[profile.product][answers[2]]}`;
      const secondary = root.querySelector('[data-ts-secondary]');
      secondary.hidden = scores[ranked[1]] < 3;
      if (!secondary.hidden) secondary.textContent = `Hai anche una vena da ${profiles[ranked[1]].title.toLowerCase()}: se vuoi, esplora la Box componibile e scegli qualche gusto fuori dalla selezione proposta.`;
      root.querySelectorAll('[data-ts-product]').forEach(card => { card.hidden = card.dataset.tsProduct !== profile.product; });
      root.querySelector('[data-ts-result-title]').setAttribute('tabindex', '-1');
      root.querySelector('[data-ts-result-title]').focus({ preventScroll: true });
      result.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    root.querySelector('[data-ts-start]').addEventListener('click', () => { index = 0; answers = []; renderQuestion(); });
    root.querySelector('[data-ts-back]').addEventListener('click', () => { if (index > 0) { index -= 1; renderQuestion(); } });
    root.querySelector('[data-ts-restart]').addEventListener('click', () => { index = 0; answers = []; renderQuestion(); });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
